/**
 * AnimatedStarburst — Compact TuesdayOS starburst icon
 *
 * 8-arm starburst that assembles on mount, breathes gently,
 * and re-assembles on tap. Used as the mobile header logo.
 *
 * Adapted from ProvisioningScreen's AssemblingLogo (simplified for header use).
 */

import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const ARMS: { dx: number; dy: number; elements: string[] }[] = [
  { dx: 0, dy: -1, elements: [
    '<path d="M190 16C190 14.2928 189.664 12.6023 189.01 11.0251C188.357 9.44788 187.4 8.01477 186.192 6.80761C184.985 5.60045 183.552 4.64288 181.975 3.98957C180.398 3.33625 178.707 3 177 3C175.293 3 173.602 3.33626 172.025 3.98957C170.448 4.64288 169.015 5.60045 167.808 6.80761C166.6 8.01477 165.643 9.44788 164.99 11.0251C164.336 12.6023 164 14.2928 164 16L177 16H190Z" fill="#0051FD"/>',
    '<rect x="164" y="16" width="26" height="120" fill="#0051FD"/>',
    '<path d="M177 147L164 136L190 136L177 147Z" fill="#0051FD"/>',
  ]},
  { dx: 0, dy: 1, elements: [
    '<path d="M164 338C164 339.707 164.336 341.398 164.99 342.975C165.643 344.552 166.6 345.985 167.808 347.192C169.015 348.4 170.448 349.357 172.025 350.01C173.602 350.664 175.293 351 177 351C178.707 351 180.398 350.664 181.975 350.01C183.552 349.357 184.985 348.4 186.192 347.192C187.4 345.985 188.357 344.552 189.01 342.975C189.664 341.398 190 339.707 190 338L177 338L164 338Z" fill="#0051FD"/>',
    '<rect x="190" y="338" width="26" height="120" transform="rotate(180 190 338)" fill="#0051FD"/>',
    '<path d="M177 207L190 218L164 218L177 207Z" fill="#0051FD"/>',
  ]},
  { dx: 1, dy: 0, elements: [
    '<path d="M338 190C339.707 190 341.398 189.664 342.975 189.01C344.552 188.357 345.985 187.4 347.192 186.192C348.4 184.985 349.357 183.552 350.01 181.975C350.664 180.398 351 178.707 351 177C351 175.293 350.664 173.602 350.01 172.025C349.357 170.448 348.4 169.015 347.192 167.808C345.985 166.6 344.552 165.643 342.975 164.99C341.398 164.336 339.707 164 338 164L338 177L338 190Z" fill="#0051FD"/>',
    '<rect x="338" y="164" width="26" height="120" transform="rotate(90 338 164)" fill="#0051FD"/>',
    '<path d="M207 177L218 164L218 190L207 177Z" fill="#0051FD"/>',
  ]},
  { dx: -1, dy: 0, elements: [
    '<path d="M16 164C14.2928 164 12.6023 164.336 11.0251 164.99C9.44788 165.643 8.01477 166.6 6.80761 167.808C5.60045 169.015 4.64288 170.448 3.98957 172.025C3.33625 173.602 3 175.293 3 177C3 178.707 3.33625 180.398 3.98957 181.975C4.64288 183.552 5.60045 184.985 6.80761 186.192C8.01477 187.4 9.44788 188.357 11.0251 189.01C12.6023 189.664 14.2928 190 16 190L16 177L16 164Z" fill="#0051FD"/>',
    '<rect x="16" y="190" width="26" height="120" transform="rotate(-90 16 190)" fill="#0051FD"/>',
    '<path d="M147 177L136 190L136 164L147 177Z" fill="#0051FD"/>',
  ]},
  { dx: 0.707, dy: 0.707, elements: [
    '<path d="M282.302 300.071C283.509 301.278 284.942 302.236 286.519 302.889C288.096 303.542 289.787 303.879 291.494 303.879C293.201 303.879 294.892 303.542 296.469 302.889C298.046 302.236 299.479 301.278 300.687 300.071C301.894 298.864 302.851 297.431 303.505 295.854C304.158 294.276 304.494 292.586 304.494 290.879C304.494 289.171 304.158 287.481 303.505 285.904C302.851 284.327 301.894 282.893 300.687 281.686L291.494 290.879L282.302 300.071Z" fill="#0051FD"/>',
    '<rect x="300.686" y="281.686" width="26" height="120" transform="rotate(135 300.686 281.686)" fill="#0051FD"/>',
    '<path d="M198.862 198.248L215.833 196.833L197.448 215.218L198.862 198.248Z" fill="#0051FD"/>',
  ]},
  { dx: -0.707, dy: -0.707, elements: [
    '<path d="M72.999 53.9978C71.7919 52.7906 70.3588 51.8331 68.7815 51.1798C67.2043 50.5264 65.5138 50.1902 63.8066 50.1902C62.0995 50.1902 60.409 50.5264 58.8318 51.1798C57.2545 51.8331 55.8214 52.7906 54.6143 53.9978C53.4071 55.205 52.4495 56.6381 51.7962 58.2153C51.1429 59.7925 50.8067 61.483 50.8067 63.1902C50.8067 64.8974 51.1429 66.5878 51.7962 68.1651C52.4495 69.7423 53.4071 71.1754 54.6143 72.3826L63.8066 63.1902L72.999 53.9978Z" fill="#0051FD"/>',
    '<rect x="54.6152" y="72.3826" width="26" height="120" transform="rotate(-45 54.6152 72.3826)" fill="#0051FD"/>',
    '<path d="M156.438 155.821L139.468 157.235L157.853 138.85L156.438 155.821Z" fill="#0051FD"/>',
  ]},
  { dx: 0.707, dy: -0.707, elements: [
    '<path d="M300.071 72.6987C301.278 71.4916 302.236 70.0585 302.889 68.4812C303.543 66.904 303.879 65.2135 303.879 63.5064C303.879 61.7992 303.543 60.1087 302.889 58.5315C302.236 56.9542 301.278 55.5211 300.071 54.314C298.864 53.1068 297.431 52.1492 295.854 51.4959C294.277 50.8426 292.586 50.5064 290.879 50.5064C289.172 50.5064 287.481 50.8426 285.904 51.4959C284.327 52.1492 282.894 53.1068 281.687 54.314L290.879 63.5064L300.071 72.6987Z" fill="#0051FD"/>',
    '<rect x="281.686" y="54.314" width="26" height="120" transform="rotate(45 281.686 54.314)" fill="#0051FD"/>',
    '<path d="M198.247 156.137L196.833 139.167L215.218 157.552L198.247 156.137Z" fill="#0051FD"/>',
  ]},
  { dx: -0.707, dy: 0.707, elements: [
    '<path d="M53.999 282.002C52.7919 283.21 51.8343 284.643 51.181 286.22C50.5277 287.797 50.1914 289.488 50.1914 291.195C50.1914 292.902 50.5277 294.592 51.181 296.17C51.8343 297.747 52.7919 299.18 53.999 300.387C55.2062 301.594 56.6393 302.552 58.2165 303.205C59.7938 303.859 61.4842 304.195 63.1914 304.195C64.8986 304.195 66.5891 303.859 68.1663 303.205C69.7435 302.552 71.1766 301.594 72.3838 300.387L63.1914 291.195L53.999 282.002Z" fill="#0051FD"/>',
    '<rect x="72.3848" y="300.387" width="26" height="120" transform="rotate(-135 72.3848 300.387)" fill="#0051FD"/>',
    '<path d="M155.823 198.564L157.237 215.534L138.853 197.15L155.823 198.564Z" fill="#0051FD"/>',
  ]},
];

const FLY_DIST = 120;
const FLY_IN_S = 0.5;
const STAGGER = 0.04;
const HOLD_S = 5;
const FLY_OUT_S = 0.3;
const PAUSE_S = 0.3;
interface Props {
  size?: number;
  className?: string;
  onClick?: () => void;
  /** Increment to trigger a fresh fly-in */
  replayTrigger?: number;
}

export function AnimatedStarburst({ size = 28, className, onClick, replayTrigger = 0 }: Props) {
  const [cycle, setCycle] = useState(0);
  const isOut = cycle % 2 === 1;

  // External replay trigger — force fly-out then fly-in
  useEffect(() => {
    if (replayTrigger > 0) {
      // Jump to fly-out, then the cycle timer will trigger fly-in
      setCycle((c) => (c % 2 === 0 ? c + 1 : c + 2));
    }
  }, [replayTrigger]);

  // Cycle timing: fly-in → hold → fly-out → pause → repeat
  useEffect(() => {
    const totalIn = (FLY_IN_S + STAGGER * ARMS.length) * 1000;
    const totalOut = (FLY_OUT_S + STAGGER * ARMS.length) * 1000;
    const delay = isOut ? totalOut + PAUSE_S * 1000 : totalIn + HOLD_S * 1000;
    const timer = setTimeout(() => setCycle((c) => c + 1), delay);
    return () => clearTimeout(timer);
  }, [cycle, isOut]);

  // Tap triggers immediate re-assembly
  const handleTap = () => {
    setCycle((c) => (c % 2 === 0 ? c + 1 : c + 2));
    onClick?.();
  };

  return (
    <svg
      viewBox="0 0 355 354"
      width={size}
      height={size}
      className={className}
      onClick={handleTap}
      role="img"
      aria-label="Zaviago"
    >
      {ARMS.map((arm, i) => {
        const offX = arm.dx * FLY_DIST;
        const offY = arm.dy * FLY_DIST;

        return (
          <motion.g
            key={i}
            initial={{ x: offX, y: offY, opacity: 0 }}
            animate={
              isOut
                ? { x: offX, y: offY, opacity: 0 }
                : { x: 0, y: 0, opacity: 1 }
            }
            transition={{
              duration: isOut ? FLY_OUT_S : FLY_IN_S,
              delay: i * STAGGER,
              ease: [0.32, 0.72, 0, 1],
            }}
            dangerouslySetInnerHTML={{ __html: arm.elements.join("") }}
          />
        );
      })}
    </svg>
  );
}
